import axiosCore from 'axios';
import { API_TIMEOUT, API_ENDPOINT } from '#/config/constant';

const axios = axiosCore.create({
  timeout: API_TIMEOUT,
});

const uri = new URL(API_ENDPOINT!);

axios.defaults.baseURL = uri.origin;
axios.defaults.headers.common['content-type'] = 'application/json';

export default axios;
